import { FC, useState } from "react";

type IProps = {
  activeTab: string;
  handleTabChange: (x: string) => void;
};

const FilterNews: FC<IProps> = ({ activeTab, handleTabChange }) => {
  return (
    <div className="flex text-[13px] font-semibold">
      <div data-tab="allNews">
        <button
          className={`${
            activeTab === "allNews"
              ? "px-2.5 py-1 border-2 border-orange text-orange rounded-full"
              : "px-2.5 py-1 border border-light_gray rounded-full"
          } px-1.5 mr-2`}
          onClick={() => handleTabChange("allNews")}
        >
          Усі новини
        </button>
      </div>
      <div data-tab="textNews">
        {/* <button
          className={`${
            activeTab === "textNews"
              ? "px-2.5 py-1 border-2 border-orange text-orange rounded-full"
              : "px-2.5 py-1 border border-light_gray rounded-full"
          } px-1.5 mx-2`}
          onClick={() => handleTabChange("textNews")}
        >
          Текстові
        </button> */}
      </div>
      <div data-tab="videoNews">
        <button
          className={`${
            activeTab === "videoNews"
              ? "px-2.5 py-1 border-2 border-orange text-orange rounded-full"
              : "px-2.5 py-1 border border-light_gray rounded-full"
          } px-1.5 `}
          onClick={() => handleTabChange("videoNews")}
        >
          Відео
        </button>
      </div>
    </div>
  );
};

export default FilterNews;
